import React from 'react'

import { Input } from '@cvg/react-components'

import { useFiltersContext } from '@contexts/FilterContext'

const Search = () => {
  const { filters, setFilter } = useFiltersContext()

  return (
    <Input
      key={filters.searchText}
      label='Keywords'
      type='search'
      placeholder='Graduation'
      defaultTerms={filters.searchText}
      name='search'
      onSubmit={searchText => setFilter({ searchText })}
    />
  )
}

export default Search
